<template>
  <div class="login">
    <div class="login-left">
      <img src="customize/logo.png"
           alt=""
           srcset=""
           class="login-left__logo">
      <section class="login-left__title">
        <p>欢迎回来</p>
        <h1>{{option.title}}</h1>
      </section>
      <p class="login-left__copy">{{option.copyrightstr}}</p>
    </div>
    <div class="login-right">
      <h2>账号登录</h2>
      <section>
        <el-form :model="loginForm"
                 :rules="loginRules"
                 ref="loginForm"
                 :hide-required-asterisk="true"
                 class="demo-ruleForm"
                 v-show="isLogin">
          <el-form-item label="账户类型"
                        prop="type"
                        v-show="enableIPA">
            <el-select v-model="loginForm.type"
                       filterable
                       placeholder="请选择账户类型"
                       @change="submitForm('loginForm')">
              <el-option v-for="inputItem in inputItems"
                         :key="inputItem.value"
                         :label="inputItem.label"
                         :value="inputItem.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账号/用户名"
                        prop="username">
            <el-input v-model="loginForm.username"
                      placeholder="请输入手机号/邮箱/用户名/工号"
                      v-on:keyup.enter.native="submitForm('loginForm')"></el-input>
          </el-form-item>
          <el-form-item label="密码"
                        prop="password">
            <el-input v-model="loginForm.password"
                      type="password"
                      placeholder="请输入密码"
                      v-on:keyup.enter.native="submitForm('loginForm')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       @click="submitForm('loginForm')">{{ loginText }}
            </el-button>
          </el-form-item>
        </el-form>

        <el-form :model="setForm"
                 :rules="setRules"
                 ref="setForm"
                 :hide-required-asterisk="true"
                 class="demo-ruleForm"
                 v-show="!isLogin">
          <el-form-item label="账号/用户名"
                        prop="username">
            <el-input v-model="setForm.username"
                      placeholder="请输入手机号/邮箱/用户名/工号"
                      v-on:keyup.enter.native="submitForm('setForm')"></el-input>
          </el-form-item>
          <el-form-item label="初始化密码"
                        prop="password">
            <el-input v-model="setForm.password"
                      type="password"
                      placeholder="请输入密码"
                      v-on:keyup.enter.native="submitForm('setForm')"></el-input>
          </el-form-item>
          <el-form-item label="新密码"
                        prop="newPassword">
            <el-input v-model="setForm.newPassword"
                      type="password"
                      placeholder="请输入新密码"
                      v-on:keyup.enter.native="submitForm('setForm')"></el-input>
          </el-form-item>
          <el-form-item label="再次确认新密码"
                        prop="checkPwd">
            <el-input v-model="setForm.checkPwd"
                      type="password"
                      placeholder="请再次输入新密码"
                      v-on:keyup.enter.native="submitForm('setForm')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       class="set-btn"
                       @click="submitForm('setForm')">{{ loginText }}
            </el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',

  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (!this.enhanceSecurity) {
          callback();
          return
        }
        if (value.length < 8) {
          callback(new Error('新密码不满足8位，请重新输入'));
        } else {
          !this.reg.test(value) && callback(new Error('新密码必须包含数字/大写字母/小写字母/字符中的3种'));
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.setForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      isLogin: true, // 切换登录和重置密码
      encryptMethod: 'md5', // 加密方式
      enhanceSecurity: false, // 开启复杂验证
      authorize: {}, // 接口认证信息
      enableIPA: false, // 是否显示下拉框
      titleMain: '', // title
      loginText: '登录',
      inputItems:[
        {
          label:'FreeIPA',
          value:'ldap'
        },
        {
          label:'普通账户',
          value:''
        }
      ],
      tipObject: {
        'InvalidUsernameOrPassword': '无效的用户名密码',
        'PasswordExpired': '密码过期',
        'SamePassword': '新密码不能与原密码相同',
        'BadPassword': '新密码强度太弱',
        'InternalError': '服务器错误',
        'defaultError': '无效的用户名密码',
        'AccountLocked': '密码错误次数过多，请稍后重试'
      },
      reg: new RegExp(/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{1,}$/),
      loginForm: {
        type:'ldap',
        username: '',
        password: ''
      },
      setForm: {
        username: '',
        password: '',
        newPassword: '',
        checkPwd: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入账号/用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      setRules: {
        username: [
          { required: true, message: '请输入账号/用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        newPassword: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPwd: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      option: {
        title: '',
        copyrightstr: ''
      }
    };
  },
  created () {
    var t = this;
    // document.onkeydown = function (e) {
    //   var key = window.event.keyCode;
    //   if (key == 13) {
    //     t.submitForm();
    //   }
    // }
    this.$api.setInstance(this)
    this.getOptions()
  },
  mounted () {
    let url = window.location.search;
    let urlObj = {};
    if (url) {
      url = url.split("?")[1];
      if (url.indexOf('&') != -1) {
        let param = url.split("&");
        for (var i = 0; i < param.length; i++) {
          let val = param[i].split("=");
          urlObj[val[0]] = val[1];
        }
      } else {
        let val = url.split("=");
        urlObj[val[0]] = val[1];
      }
    }
    let error_code = urlObj.error_code
    if (error_code) {
      let text = this.tipObject[error_code] ? this.tipObject[error_code] : this.tipObject['defaultError'];
      this.$message({
        type: 'error',
        message: text
      })
      if (urlObj.error_code == 'PasswordExpired') {
        this.isLogin = false
      }
    }
    // this.titleMain = urlObj.client_name || '医疗大数据平台';
    this.authorize = {
      response_type: urlObj.response_type,
      client_id: urlObj.client_id,
      redirect_uri: decodeURIComponent(urlObj.redirect_uri),
      scope: urlObj.scope,
      state: urlObj.state
    }
  },

  methods: {
    getOptions () {
      this.$api.user.option().then(res => {
        this.enhanceSecurity = res.enhanceSecurity
        this.encryptMethod = res.encryptMethod
        this.enableIPA = res.enableIPA
        this.option = res
      }).catch(err => {
        console.log(err)
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        const encrypt = this.encryptMethod === 'sha256' ? this.$sha256 : this.$md5
        if (valid) {
          this.loginText = '登录中...'
          let form = this[formName]
          let authorize = this.authorize
          let params = JSON.parse(JSON.stringify(form))
          // FreeIPA 账户 密码用明文
          !this.enableIPA && (params.type = "")
          form.password && (params.password = this.isLogin && this.loginForm.type && this.enableIPA ? form.password :encrypt(form.password))
          form.newPassword && (params.newPassword = encrypt(form.newPassword))
          form.checkPwd && (params.checkPwd = encrypt(form.checkPwd))
          this.$api.user.auth({ authorize, ...params }).then(res => {
            this.loginText = '登录'
            window.location.href = res.redirectURI;
          }).catch(err => {
            this.loginText = '登录'
            let error_code = err.data.error;
            let text = this.tipObject[error_code] ? this.tipObject[error_code] : this.tipObject['defaultError'];
            if (error_code == 'PasswordExpired') {
              this.setForm.username = this.loginForm.username
              this.isLogin = false
            }
            this.$message({
              type: 'error',
              message: text
            })
          })
        } else {
          console.log('登录失败');
          return false;
        }
      });

    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  &-left {
    background: url("../assets/images/tu.jpg") no-repeat;
    background-size: cover;
    width: calc(100% - 600px);
    color: #fff;
    left: 0;
    top: 0;
    bottom: 0;
    position: absolute;
    // min-width: 1260px;
    &__logo {
      width: 300px;
      margin: 91px 0 0 103px;
    }

    &__title {
      margin: 200px 0 0 200px;

      p {
        font-size: 40px;
        font-family: PingFangSC-Thin;
        margin: 20px 0;
      }

      h1 {
        font-size: 50px;
        font-family: PingFangSC-Semibold;
        margin: 20px 0;
      }
    }

    &__copy {
      font-size: 14px;
      position: absolute;
      bottom: 60px;
      left: 200px;
      opacity: 0.4;
      font-family: PingFangSC-Regular;
      line-height: 24px;
    }
  }

  &-right {
    width: 600px;
    padding: 60px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    background: #fff;
    right: 0;
    top: 0;
    bottom: 0;

    h2 {
      font-family: PingFangSC-Semibold;
      font-size: 36px;
      color: #333333;
      width: 400px;
    }

    section {
      margin-top: 50px;

      .set-btn {
        margin-top: 50px;
      }
    }
  }
}
</style>
